import {
  CustomFieldsFieldFragment,
  CustomFieldsValueFragment,
  EmployeeEditInBulkPageQuery,
} from 'generated/resources/graphql'

// structure for one change that will be associated to a employee
export interface Change {
  manager_id?: number
  location_id?: number
  timeoff_manager_id?: number
  timeoff_policy_id?: number
  regular_access_starts_on?: string
  teams_ids?: number[]
  legal_entity_id?: number
  permission_group_id?: number
  employee_group_id?: number
  [key: string]: CustomFieldValue
}

export type CustomFieldValue = number | string | number[] | null | undefined

export interface CustomFieldsWithValues {
  [key: number]: CustomFieldValue
}

// structure for association of employee id and a change
export type ChangesByEmployee = Map<number, Change>

export type EmployeeGroups = EmployeeEditInBulkPageQuery['employees']['employeeGroups'][number]

export type CustomField = CustomFieldsFieldFragment

export type EmployeeCustomFieldsValue = CustomFieldsValueFragment

export const COLUMNSWIDTH = 230
export const ROW_HEIGHT = 73
export const HEADER_HEIGHT = 70
